module.exports = __webpack_public_path__ + "img/20190523203357微信截图_20190523203755.497441f8.png";